<template>
  <div v-if="worker" class=" d-flex justify-center align-center" style="width:100%">
    <v-card @click.stop="details()" flat class=" box-card pa-0">
      <v-avatar class="profile" color="grey">
        <v-img
          :aspect-ratio="1 / 1"
          v-if="worker.image.length > 0 && !setInitials"
          :src="baseUrl"
          v-on:error="setInitials = true"
        />
        <span v-else class="white--text header-fg-alt" v-text="initials" />
      </v-avatar>
      <div class="bottom-section d-flex">
        <h6 v-text="name" />
        <span class="position body" v-text="position" />
        <div class=" mt-2">
          <a class="links" :href="`tel:${worker.phone}`" v-text="worker.phone" />
          <span class="links pl-4" v-html="ext" />
        </div>
        <div>
          <a class="links" :href="`mailto:${worker.email}`" v-text="worker.email" />
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  name: "NoticiasCell",
  props: {
    worker: Object,
    workerDetails: Function
  },
  methods: {
    details() {
      const { worker, workerDetails } = this;
      if (workerDetails) workerDetails(worker, true);
    }
  },
  computed: {
    baseUrl() {
      const fileName = this.worker.image;
      return $(location).attr("origin") + "/archivos/personal/" + fileName;
    },
    name() {
      return this.worker.name + " " + this.worker.lastName;
    },
    ext() {
      const { ext } = this.worker;
      return ext.length > 0 ? `ext. ${ext}` : null;
    },
    initials() {
      const { worker } = this;
      return worker.name.charAt(0) + worker.lastName.charAt(0);
    },
    position() {
      return this.worker.position.toLowerCase();
    }
  },
  data() {
    return {
      setInitials: false
    };
  }
};
</script>
<style lang="scss" scoped>
.box-card {
  width: 100%;
  display: flex;
  // justify-content: center;
  align-items: center;
  flex-direction: row;
  // min-width: 445px;
  // max-width: 445px;
  height: 118px;
  margin: 10px;
  display: flex;
}
.profile {
  height: 102px !important;
  width: 102px !important;
}
.header-fg-alt {
  color: #222a42;
  line-height: 1.05;
  font-weight: 400;
  font-size: 47px;
  font-family: "Poppins";
  text-transform: capitalize;
}
.bottom-section {
  // flex: 1;
  padding-top: 10px;
  flex-direction: column;
  padding-left: 15px;
  .position::first-letter {
    text-transform:capitalize;
}
}
@media (max-width: 960px) {
  .profile {
    height: 140px !important;
    width: 140px !important;
  }
  .box-card {
    min-width: 0;
    width: 295px;
    flex-direction: column;
    height: auto;
  }
  .bottom-section {
    // flex: 1;
    padding: 0;
    margin-top: 20px;
    text-align: center;
    * {
      text-align: center;
    }
  }
}
</style>
